import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-code',
      title: 'Software Development'
    },
    {
      icon: 'fas fa-bullhorn',
      title: 'Marketing Services'
    },
    {
      icon: 'fas fa-mobile-alt',
      title: 'App Development'
    },
    {
      icon: 'fas fa-share-alt',
      title: 'Social Media Marketing'
    }
  ];

  const values = [
    {
      icon: 'fas fa-shield-alt',
      title: 'Integrity',
      description: 'Transparency and trust in every business relationship.'
    },
    {
      icon: 'fas fa-award',
      title: 'Professionalism',
      description: 'Compliance with UAE regulations and international best practices.'
    },
    {
      icon: 'fas fa-lightbulb',
      title: 'Innovation',
      description: 'Modern approach to business management and investment strategies.'
    },
    {
      icon: 'fas fa-seedling',
      title: 'Growth',
      description: 'Continuous focus on development and value creation for our stakeholders.'
    }
  ];

  return (
    <section 
      id="services" 
      className="py-5 bg-light"
      style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}
    >
      <Container>
        <Row>
          <Col lg={8} className="mx-auto text-center mb-5">
            <h2 
              className="mb-4"
              data-aos="fade-up"
              style={{
                position: 'relative',
                marginBottom: '3rem'
              }}
            >
              Our Services
              <div
                style={{
                  content: '""',
                  position: 'absolute',
                  bottom: '-10px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '60px',
                  height: '3px',
                  background: 'linear-gradient(45deg, #007bff, #0056b3)',
                  borderRadius: '2px'
                }}
              />
            </h2>
            <p 
              className="lead"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              We specialize in four core areas that drive business success and growth
            </p>
          </Col>
        </Row>
        
        <Row className="justify-content-center">
          {services.map((service, index) => (
            <Col lg={4} md={5} className="mb-4" key={index}>
              <Card 
                className="h-100 shadow"
                data-aos="fade-up"
                data-aos-delay={index * 200}
                style={{
                  border: 'none',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 0.5rem 1rem rgba(0, 0, 0, 0.15)';
                }}
              >
                <Card.Body 
                  className="text-center"
                  style={{ padding: '2.5rem' }}
                >
                  <i 
                    className={`${service.icon} text-primary mb-4`}
                    style={{ fontSize: '3rem' }}
                  />
                  <h4 
                    className="card-title mb-0"
                    style={{ color: '#333', fontWeight: '600' }}
                  >
                    {service.title}
                  </h4>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Our Values Section */}
        <Row className="mt-5">
          <Col lg={8} className="mx-auto text-center mb-5">
            <h2 
              className="mb-4"
              data-aos="fade-up"
              style={{
                position: 'relative',
                marginBottom: '3rem'
              }}
            >
              Our Values
              <div
                style={{
                  content: '""',
                  position: 'absolute',
                  bottom: '-10px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '60px',
                  height: '3px',
                  background: 'linear-gradient(45deg, #007bff, #0056b3)',
                  borderRadius: '2px'
                }}
              />
            </h2>
          </Col>
        </Row>

        <Row>
          {values.map((value, index) => (
            <Col lg={3} md={6} className="mb-4" key={index}>
              <div 
                className="text-center"
                data-aos="fade-up"
                data-aos-delay={index * 100}
                style={{
                  padding: '2rem 1rem',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <i 
                  className={`${value.icon} text-primary mb-3`}
                  style={{ fontSize: '2.5rem' }}
                />
                <h5 
                  style={{ 
                    color: '#333', 
                    fontWeight: '600',
                    marginBottom: '1rem'
                  }}
                >
                  {value.title}
                </h5>
                <p 
                  style={{ 
                    color: '#666',
                    fontSize: '0.95rem'
                  }}
                >
                  {value.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Services;
